import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-pressable',
  templateUrl: './pressable.component.html',
  styleUrls: ['./pressable.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLinkActive, NgClass, RouterLink],
})
export class PressableComponent {
  @Input() href: string | undefined = undefined;
  @Input() routerLink: string | undefined = undefined;
  @Input({ required: true }) label = '';
  @Input() variant: 'brand' | 'flat' | 'outline' = 'flat';
}
